import React, { createContext, useContext, useEffect } from 'react';
import { ProgressLoadingBar } from '@ohif/ui';
import { ShareLinkVM } from '@/viewModel/ShareLink/ShareLinkVM';
import { shareLinkHelper } from '@/utils';

type Props = {
  children?: React.ReactNode;
};

const shareLinkVMContext = createContext<ShareLinkVM>(null);

export const useShareLinkVMContext = () => {
  const shareLinkVM = useContext(shareLinkVMContext);
  return { shareLinkVM };
};

export const ShareLinkProvider = ({ children }: Props) => {
  const shareLinkVM = new ShareLinkVM();
  const { shareToken, isShareLinkPage, studyInstanceUIDs } = shareLinkHelper.getCurrentUrlInfo();

  /**
   * 解析分享影像網址
   */
  const parseShareLinkUrl = async () => {
    const data = await shareLinkVM.init(shareToken);

    if (isShareLinkPage && !studyInstanceUIDs) {
      window.location.replace(`/viewer?StudyInstanceUIDs=${data.study_uid_list}&share_token=${shareToken}`);
      return;
    }
  };

  useEffect(() => {
    if (isShareLinkPage) {
      parseShareLinkUrl();
    }
  }, []);

  return (
    <shareLinkVMContext.Provider value={shareLinkVM}>
      {(isShareLinkPage && !studyInstanceUIDs) ? (
        <div
          className="w-full h-full pt-[24px] px-[24px] bg-gray-111 text-white overflow-y-auto scrollbar-primary"
          style={{ height: '100dvh' }}
        >
          <div className="w-full flex flex-col items-center justify-center pt-48">
            <div className="w-full max-w-[192px]">
              <ProgressLoadingBar />
            </div>
          </div>
        </div>
      ) : (
        children
      )}
    </shareLinkVMContext.Provider>
  );
};
